import _defineProperty from '../../../../node_modules/@babel/runtime/helpers/defineProperty.es.js';
import _slicedToArray from '../../../../node_modules/@babel/runtime/helpers/slicedToArray.es.js';
import { Transition } from '@mgmresorts/wcl-utils';
import React, { useContext, useState, useLayoutEffect } from 'react';
import useDebouncedCallback from '../../../../node_modules/use-debounce/esm/useDebouncedCallback.es.js';
import { ViewportContext } from '../ViewportContext/ViewportContext.es.js';
import '@mgmresorts/wcl-styled';
import { ModalTransitionTimes } from './Modal.types.es.js';
import { ModalContainer } from './ModalContainer/ModalContainer.es.js';
import { ModalContent } from './ModalContent/ModalContent.es.js';
import '../RoomBookingNavigation/RoomBookingNavigation.es.js';
import '../RoomBookingNavigation/elements/CenteredNavTitle.es.js';
import '../RoomBookingNavigation/elements/CenterPropertyLogo.es.js';
import '../RoomBookingNavigation/elements/LeftBackButton.es.js';
import '../RoomBookingNavigation/elements/LeftCloseButton.es.js';
import '../DropdownMenu/MenuTrigger/MenuTrigger.es.js';
import '../DropdownMenu/MenuTrigger/MenuContent.styles.es.js';
import '../DropdownMenu/MenuButton/MenuButton.es.js';
import '../MlifeMenu/MlifeMenu/MlifeMenu.es.js';
import '../MlifeMenu/MlifeMenu/MlifeMenuLoginForm.es.js';
import '../../../../node_modules/@babel/runtime/helpers/typeof.es.js';
import '../Box/Box.es.js';
import '../Box/FlexColumn.es.js';
import '../Box/FlexRow.es.js';
import '../Box/GridColumn.es.js';
import '../Box/GridRow.es.js';
import '../Button/Button.es.js';
import '../Button/FixedButton.es.js';
import '../Button/Button.styles.es.js';
import '../ButtonGroup/ButtonGroup.es.js';
import '../Text/Text.es.js';
import '../MlifeMenu/MlifeMenu/MlifeMenuSignedOut.styles.es.js';
import '../MlifeMenu/MlifeMenu/MlifeMenuSignedIn.es.js';
import '../MlifeMenu/MlifeMenu/TierProgressBar.es.js';
import '../MlifeMenu/MlifeMenuTrigger/MlifeMenuButton.es.js';
import '../MlifeMenu/MlifeMenuTrigger/MlifeMenuTrigger.es.js';
import '../Icons/icons/createIcon.es.js';
import '../Icons/icons/AdultsOnlyIcon.es.js';
import '../Icons/icons/AttractionsIcon.es.js';
import '../Icons/icons/BackIcon.es.js';
import '../Icons/icons/BarberIcon.es.js';
import '../Icons/icons/BedIcon.es.js';
import '../Icons/icons/BestRateGuaranteedIcon.es.js';
import '../Icons/icons/CalendarIcon.es.js';
import '../Icons/icons/CartIcon.es.js';
import '../Icons/icons/ChairIcon.es.js';
import '../Icons/icons/CheckIcon.es.js';
import '../Icons/icons/CirqueIcon.es.js';
import '../Icons/icons/CloseCircleFilledIcon.es.js';
import '../Icons/icons/CloseIcon.es.js';
import '../Icons/icons/ComedyIcon.es.js';
import '../Icons/icons/ConcertsIcon.es.js';
import '../Icons/icons/CouchIcon.es.js';
import '../Icons/icons/CreditCardIcon.es.js';
import '../Icons/icons/CulinaryIcon.es.js';
import '../Icons/icons/DesertViewIcon.es.js';
import '../Icons/icons/DrinkIcon.es.js';
import '../Icons/icons/DropdownArrowIcon.es.js';
import '../Icons/icons/EnlargeIcon.es.js';
import '../Icons/icons/FanIcon.es.js';
import '../Icons/icons/FilterIcon.es.js';
import '../Icons/icons/ForwardIcon.es.js';
import '../Icons/icons/FreeCancellationIcon.es.js';
import '../Icons/icons/GridDisabledIcon.es.js';
import '../Icons/icons/GridEnabledIcon.es.js';
import '../Icons/icons/GuestsIcon.es.js';
import '../Icons/icons/HeartIcon.es.js';
import '../Icons/icons/HidePasswordIcon.es.js';
import '../Icons/icons/InformationCircleIcon.es.js';
import '../Icons/icons/ListViewIcon.es.js';
import '../Icons/icons/LockFilledIcon.es.js';
import '../Icons/icons/LockOutlineIcon.es.js';
import '../Icons/icons/LongArrowIcon.es.js';
import '../Icons/icons/LoungeChairIcon.es.js';
import '../Icons/icons/MagicIcon.es.js';
import '../Icons/icons/MattressIcon.es.js';
import '../Icons/icons/MenuIcon.es.js';
import '../Icons/icons/MinibarIcon.es.js';
import '../Icons/icons/MinusCircleIcon.es.js';
import '../Icons/icons/MinusIcon.es.js';
import '../Icons/icons/MlifeIcon.es.js';
import '../Icons/icons/PanoramicViewIcon.es.js';
import '../Icons/icons/PasswordXIcon.es.js';
import '../Icons/icons/PhoneIcon.es.js';
import '../Icons/icons/PlusCircleIcon.es.js';
import '../Icons/icons/PlusIcon.es.js';
import '../Icons/icons/PoolIcon.es.js';
import '../Icons/icons/ProfileIcon.es.js';
import '../Icons/icons/RefreshIcon.es.js';
import '../Icons/icons/SafeIcon.es.js';
import '../Icons/icons/SearchIcon.es.js';
import '../Icons/icons/ShowPasswordIcon.es.js';
import '../Icons/icons/ShowerIcon.es.js';
import '../Icons/icons/SortIcon.es.js';
import '../Icons/icons/SpaRocksIcon.es.js';
import '../Icons/icons/SpecialEventsIcon.es.js';
import '../Icons/icons/Spinner.es.js';
import '../Icons/icons/SportsIcon.es.js';
import '../Icons/icons/SpotCalendarIcon.es.js';
import '../Icons/icons/StripViewIcon.es.js';
import '../Icons/icons/TvIcon.es.js';
import '../Icons/icons/UmbrellaIcon.es.js';
import '../Icons/icons/WarningCircleIcon.es.js';
import '../Icons/icons/WarningTriangleFilledIcon.es.js';
import '../Icons/icons/WarningTriangleIcon.es.js';
import '../Icons/icons/WiFiIcon.es.js';
import '../Icons/icons/BestRateIcon.es.js';
import '../Icons/icons/FiveDiamondAwardIcon.es.js';
import '../Icons/icons/ForbesTravelGuideIcon.es.js';
import '../Icons/icons/AriaStackedIcon.es.js';
import '../Icons/icons/BeauRivageIcon.es.js';
import '../Icons/icons/BellagioIcon.es.js';
import '../Icons/icons/BellagioInternationalIcon.es.js';
import '../Icons/icons/BorgataIcon.es.js';
import '../Icons/icons/CircusCircusIcon.es.js';
import '../Icons/icons/DelanoIcon.es.js';
import '../Icons/icons/ExcaliburIcon.es.js';
import '../Icons/icons/GoldStrikeIcon.es.js';
import '../Icons/icons/LuxorIcon.es.js';
import '../Icons/icons/MandalyBayIcon.es.js';
import '../Icons/icons/MGMChinaIcon.es.js';
import '../Icons/icons/MGMDiayutaiIcon.es.js';
import '../Icons/icons/MGMGrandDetroitIcon.es.js';
import '../Icons/icons/MGMGrandIcon.es.js';
import '../Icons/icons/MGMGrandSanyaIcon.es.js';
import '../Icons/icons/MGMMacauIcon.es.js';
import '../Icons/icons/MGMNationalHarborIcon.es.js';
import '../Icons/icons/MGMResortIcon.es.js';
import '../Icons/icons/MGMSpringfieldIcon.es.js';
import '../Icons/icons/MirageIcon.es.js';
import '../Icons/icons/MyVegasIcon.es.js';
import '../Icons/icons/NYNYIcon.es.js';
import '../Icons/icons/ParkMGMIcon.es.js';
import '../Icons/icons/SignatureIcon.es.js';
import '../Icons/icons/VdaraIcon.es.js';
import '../Icons/icons/FacebookIcon.es.js';
import '../Icons/icons/TwitterIcon.es.js';
import '../Icons/icons/YouTubeIcon.es.js';
import '../Icons/icons/PinterestIcon.es.js';
import '../Icons/icons/InstagramIcon.es.js';
import '../Icons/icons/PlayMGMIcon.es.js';
import '../Icons/icons/MGMGRIResortIcon.es.js';
import '../MlifeMenu/MlifeMenuTrigger/MobileModelHeader.styles.es.js';
import '../RoomBookingNavigation/elements/ShoppingCart.es.js';
import './ModalContent/ModalContent.styles.es.js';
import './ModalContent/BottomModalContent/BottomModalContent.styles.es.js';
import './ModalContent/CenteredModalContent/CenteredModalContent.es.js';
import './ModalContent/FullscreenModalContent/FullscreenModalContent.es.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var useDelayedOpen = function useDelayedOpen(open, _ref) {
  var _ref$enter = _ref.enter,
      enter = _ref$enter === void 0 ? 0 : _ref$enter,
      _ref$exit = _ref.exit,
      exit = _ref$exit === void 0 ? 0 : _ref$exit;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      delayedOpen = _useState2[0],
      setDelayedOpen = _useState2[1];

  var _useDebouncedCallback = useDebouncedCallback(function () {
    setDelayedOpen(true);
  }, enter),
      _useDebouncedCallback2 = _slicedToArray(_useDebouncedCallback, 2),
      triggerOpen = _useDebouncedCallback2[0],
      cancelOpen = _useDebouncedCallback2[1];

  var _useDebouncedCallback3 = useDebouncedCallback(function () {
    setDelayedOpen(false);
  }, exit),
      _useDebouncedCallback4 = _slicedToArray(_useDebouncedCallback3, 2),
      triggerClose = _useDebouncedCallback4[0],
      cancelClose = _useDebouncedCallback4[1];

  useLayoutEffect(function () {
    if (open) {
      triggerOpen();
    } else {
      triggerClose();
    }

    return function () {
      cancelOpen();
      cancelClose();
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [open]);

  if (open && enter === 0) {
    return open;
  }

  if (!open && exit === 0) {
    return open;
  }

  return delayedOpen;
};

function getModalLayout(props, viewport) {
  if (viewport.minMd) {
    return props.desktopLayout;
  }

  return props.mobileLayout;
}

var getModalContainerProps = function getModalContainerProps(props, layout, viewport) {
  var debug = props.debug,
      backdrop = props.backdrop,
      closeOnBackdropClick = props.closeOnBackdropClick,
      closeOnEsc = props.closeOnEsc,
      title = props.title,
      ariaLabel = props.ariaLabel,
      onClose = props.onClose;
  var layoutProps;
  var isFullScreen = ['fullscreen', 'fullscreen-wide', 'fullscreen-narrow'].includes(layout);

  if (isFullScreen) {
    layoutProps = {
      backdropOptions: {
        backgroundColor: '#fff'
      },
      verticalAlign: 'top',
      width: '100%',
      height: '100%'
    };
  } else if (layout === 'bottom') {
    layoutProps = {
      verticalAlign: 'bottom',
      width: '100%',
      height: 'auto'
    };
  } else if (layout === 'centered' || layout === 'centered-auto') {
    layoutProps = {
      verticalAlign: 'center',
      width: 'auto',
      height: 'auto',
      paddingTop: viewport.minLg ? 64 : 32,
      paddingBottom: viewport.minLg ? 64 : 32
    };
  } else {
    throw new TypeError("Unknown Modal layout: ".concat(layout));
  }

  return _objectSpread({
    backdrop: backdrop,
    closeOnBackdropClick: closeOnBackdropClick,
    closeOnEsc: closeOnEsc,
    ariaLabel: ariaLabel || title,
    bodyScrollLockEnabled: true,
    onClose: onClose,
    debug: debug,
    transitionDuration: {
      enter: ModalTransitionTimes[layout].containerShowDuration,
      exit: ModalTransitionTimes[layout].containerHideDuration
    }
  }, layoutProps);
};

var getModalContentProps = function getModalContentProps(props, layout) {
  var title = props.title,
      titleHTML = props.titleHTML,
      alwaysShowTitle = props.alwaysShowTitle,
      onClose = props.onClose,
      closeButton = props.closeButton,
      absoluteHeader = props.absoluteHeader,
      hideHeader = props.hideHeader,
      navBottomElement = props.navBottomElement;
  return {
    layout: layout,
    onClose: onClose,
    title: title,
    titleHTML: titleHTML,
    alwaysShowTitle: alwaysShowTitle,
    closeButton: closeButton,
    absoluteHeader: absoluteHeader,
    hideHeader: hideHeader,
    navBottomElement: navBottomElement
  };
};
/**
 * [Documentation](https://mgmdigitalventures.atlassian.net/wiki/spaces/KB/pages/194576985/Modal+Gen+3.0+Room+Booking)
 */


var Modal = function Modal(props) {
  var children = props.children;
  var viewport = useContext(ViewportContext);
  var layout = getModalLayout(props, viewport);
  var transitionTimeout = {
    enter: 0,
    exit: ModalTransitionTimes[layout].dismountDelay
  };
  var containerOpen = useDelayedOpen(props.open, {
    enter: ModalTransitionTimes[layout].containerShowDelay,
    exit: ModalTransitionTimes[layout].containerHideDelay
  });
  var contentOpen = useDelayedOpen(props.open, {
    enter: ModalTransitionTimes[layout].contentShowDelay,
    exit: ModalTransitionTimes[layout].contentHideDelay
  });
  return /*#__PURE__*/React.createElement(Transition, {
    "in": props.open,
    timeout: transitionTimeout,
    appear: true,
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(ModalContainer, Object.assign({
    open: containerOpen
  }, getModalContainerProps(props, layout, viewport)), /*#__PURE__*/React.createElement(ModalContent, Object.assign({
    open: contentOpen,
    customNavbar: props.customNavbar
  }, getModalContentProps(props, layout), {
    onShowTransitionStart: props.onShowTransitionStart,
    onShowTransitionEnd: props.onShowTransitionEnd,
    onHideTransitionStart: props.onHideTransitionStart,
    onHideTransitionEnd: props.onHideTransitionEnd
  }), children)));
};
Modal.defaultProps = {
  open: true,
  desktopLayout: 'fullscreen-wide',
  mobileLayout: 'fullscreen-wide',
  backdrop: true,
  closeOnBackdropClick: true,
  closeOnEsc: true,
  debug: false
};

export { Modal };
